var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeparator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 18,
    viewBox: "0 0 11 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93019 11.701C4.82785 11.817 4.6914 11.875 4.52083 11.875C4.36391 11.875 4.22746 11.817 4.11148 11.701C3.99549 11.585 3.9375 11.4486 3.9375 11.2917C3.9375 11.1211 3.99549 10.9846 4.11148 10.8823L6.96674 8.02705C6.99403 7.99293 7.0145 8.0134 7.02814 8.08845C7.04861 8.1635 7.05885 8.25901 7.05885 8.375C7.05885 8.49098 7.04861 8.5865 7.02814 8.66155C7.0145 8.7366 6.99403 8.75707 6.96674 8.72295L4.11148 5.86769C3.99549 5.76535 3.9375 5.6289 3.9375 5.45833C3.9375 5.30141 3.99549 5.16496 4.11148 5.04898C4.22746 4.93299 4.36391 4.875 4.52083 4.875C4.6914 4.875 4.82785 4.93299 4.93019 5.04898L7.78545 7.90424C7.91508 8.02705 7.9799 8.18397 7.9799 8.375C7.9799 8.56603 7.91508 8.72295 7.78545 8.84576L4.93019 11.701Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeparator);
export default __webpack_public_path__ + "static/media/separator.3a2539ba.svg";
export { ForwardRef as ReactComponent };